import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';

interface IServiceUnavailableModal {
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function ServiceUnavailableModal({
  modalIsOpen,
  toggleModal,
}: IServiceUnavailableModal) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>IMPORTANTE:</b> devido à medida
          preventiva adotada pelo Banco Central do Brasil, a funcionalidade de
          resgate em dinheiro está temporariamente indisponível. Por favor,
          retorne daqui a alguns dias para resgatar seu prêmio.
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          OK
        </button>
      </div>
    </Modal>
  );
}
